import favorite, { Favorite } from '@gin-betting/favorite';
import { persistReducer } from '@gin-betting/persist';

export default persistReducer<Favorite.FavoriteState>(
    {
        key: favorite.constants.NAME,
        stateReconciler: false,
        blacklist: ['fetchStatus'],
    },
    favorite.reducer
);
